// Bunny Super Theme - Cute pastel bunny aesthetic
const bunnySuper = {
    id: "bunnySuper",
    name: "Pupu 🐰",
    price: 150,
    main: "#ec4899",
    light: "#f9a8d4",
    dark: "#be185d",
    bg: "#fdf2f8",
    darkBg: "#2d1a2e",
    contrastText: "#ffffff",
    isSuper: true,
    isDarkTheme: false,
    shape: "pill",
    surfaces: {
        // Light mode
        lightBg: '#fce7f3',
        lightPaper: '#fdf2f8',
        lightContainer: '#fdf2f8',
        lightOnSurface: '#2e1a28',
        lightOnSurfaceVariant: '#6d4060',
        lightOutline: '#b06090',
        // Dark mode
        containerLowest: '#2d1a2e',
        containerLow: '#1a0e1a',
        container: '#2d1a2e',
        containerHigh: '#3d2440',
        containerHighest: '#4d2e50',
        bright: '#5d3860',
        onSurface: '#ffd8f0',
        onSurfaceVariant: '#d4a0c8',
        outline: '#b06090',
        outlineVariant: '#6d4060',
        // Button colors — primary
        primaryContainer: '#d32f80',
        onPrimaryContainer: '#ffffff',
        // Button colors — secondary (outlined)
        secondaryContainer: '#4d1a3a',
        onSecondaryContainer: '#f9a8d4',
        // Button colors — secondary (filled)
        secondary: '#f9a8d4',
        onSecondary: '#4d1a3a',
        secondaryLight: '#be185d',
        onSecondaryLight: '#ffffff',
        // Button colors — inverse
        inverseSurface: '#fdf2f8',
        onInverseSurface: '#2d1a2e',
        inverseSurfaceLight: '#2d1a2e',
        onInverseSurfaceLight: '#ffd8f0',
        // Button colors — label/text
        labelColor: '#f9a8d4',
        labelColorLight: '#be185d',
        // Status colors
        success: '#4caf50',
        successLight: '#81c784',
        successDark: '#2e7d32',
        warning: '#ed6c02',
        warningLight: '#ff9800',
        warningDark: '#e65100',
        error: '#ef5350',
        errorLight: '#ff7961',
        errorDark: '#c62828',
    },
    typography: {
        headline: '"Nunito", sans-serif',
        body: '"Nunito", sans-serif',
    },
    animations: {
        taskComplete: "bounce",
        buttonHover: "shimmer",
        avatar: "float",
        cardHover: null,
    },
    effects: {
        glowColor: "#f9a8d440",
    },
    modes: {
        light: {
            background: "linear-gradient(180deg, #fdf2f8 0%, #fce7f3 40%, #fbcfe8 100%)",
            cardBg: "rgba(255, 255, 255, 0.85)",
            taskPendingText: "#ffffff",
            taskCompleteText: "#ffffff",
            coinCompletedBg: "#ec4899",
            coinPendingBg: "rgba(236, 72, 153, 0.12)",
            coinPendingText: "#ec4899",
            nameColor: "#be185d",
        },
        dark: {
            background: "linear-gradient(180deg, #2d1a2e 0%, #3d2440 50%, #2d1a2e 100%)",
            cardBg: "rgba(236, 72, 153, 0.15)",
            taskPendingText: "#ffffff",
            taskCompleteText: "#ffffff",
            coinCompletedBg: "#ec4899",
            coinPendingBg: "rgba(236, 72, 153, 0.3)",
            coinPendingText: "#ffffff",
        },
    },
    components: {
        card: {
            borderRadius: 24,
            border: "2px solid rgba(236, 72, 153, 0.15)",
            boxShadow: "0 4px 20px rgba(236, 72, 153, 0.08)",
        },
        button: {
            borderRadius: 50,
        },
        chip: {
            borderRadius: 50,
        },
        avatar: {
            borderRadius: '50%',
            border: "3px solid #f9a8d4",
        },
    },
};

export default bunnySuper;
